import { Stack } from '@mui/material';
import { NextPrevButton } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useNavigate } from 'react-router-dom';

export const BackButton = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Reimbursements);
  const isDesktop = useIsDesktop();
  const navigate = useNavigate();

  return (
    <Stack alignItems={'center'} mt={4}>
      <NextPrevButton
        callback={() => navigate('/reimbursements')}
        text={dictionary.back}
        style={
          isDesktop
            ? undefined
            : {
                button: { height: '36px' },
                text: { fontSize: '16px', fontWeight: '600' },
              }
        }
      />
    </Stack>
  );
};
